/**
 * Crypto adapter (web: WebCrypto).
 *
 * The mobile copy swaps this file for an expo-crypto backed one with the same
 * exports.
 */

/**
 * Fill a typed array with cryptographically secure random values.
 * @param {Uint8Array} array
 * @returns {Uint8Array} the same array
 */
export const getRandomValues = (array) => window.crypto.getRandomValues(array);

/**
 * The SubtleCrypto implementation (importKey, sign, ...).
 * Resolved on each call so test environments can install one late.
 * @returns {SubtleCrypto}
 */
export const getSubtle = () => window.crypto.subtle;
